// useCanSwitchAgence — true si le rôle courant peut changer d'agence
// (multi-agences). Les rôles restreints sont verrouillés sur leur agence
// côté serveur ; on masque donc le filtre agence pour eux.
import { useContext } from 'react';
import { AuthContext } from '../constants';

export const MULTI_AGENCE_ROLES = ['superAdmin', 'directeur', 'superviseur'];

export default function useCanSwitchAgence() {
    const ctx = useContext(AuthContext);
    return MULTI_AGENCE_ROLES.includes(ctx?.currentUser?.role);
}

// Id de l'agence propre de l'utilisateur connecté (ou null)
export function useUserAgenceId() {
    const ctx = useContext(AuthContext);
    const ag = ctx?.currentUser?.agence;
    if (!ag) return null;
    return typeof ag === 'object' ? ag._id : ag;
}
